import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const stringsToOptions = strings =>
  strings.map(option => ({
    value: option,
    label: option,
  }));

const timeOptions = stringsToOptions([
  "Morning",
  "Afternoon"
]);

const fields = ({ options, branchOptions }) => ({ t }) => [
  {
    key: "serviceType",
    label: t("forms.services.serviceTypeLabel", {
      defaultValue: 'How can we help you?'
    }),
    placeholder: t("forms.services.serviceTypePlaceholder", {
      defaultValue: 'Please choose a service type'
    }),
    required: true,
    type: "dropdown",
    inputProps: {
      options,
    },
  },
  {
    key: "serviceLocation",
    label: t("forms.services.serviceLocationLabel", {
      defaultValue: 'What\'s your preferred location?'
    }),
    placeholder: t("forms.services.serviceLocationPlaceholder", {
      defaultValue: 'Please choose a location'
    }),
    required: true,
    type: "dropdown",
    inputProps: {
      options: branchOptions
    },
  },
  {
    key: "bestTime",
    label: t("forms.services.bestTimeLabel", {
      defaultValue: 'What time works best for you?'
    }),
    required: true,
    type: "dropdown",
    inputProps: {
      options: timeOptions
    },
  },
  {
    type: "section",
    title: t("forms.ContactInformationSectionTitle"),
    style: {
      mt: 3
    },
    fields:
      contactFields({ t, includeAccountNumber: false }),
  },
];

const MemberServicesForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={options.formKey || moduleKey}
    fields={fields(options)}
    defaultSuccessMessageKey="forms.services.successMessage"
  />
);

export default MemberServicesForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/MemberServicesForm.js